<template lang="pug">
v-app-bar(
  :elevation="0"
  v-bind="{ ...$props, ...$attrs }"
)
  slot(name="navbar")

  v-tooltip(bottom disabled)
    template(#activator="{ on, attrs }")
      v-toolbar-title.pl-1(v-if="showTitle")
        v-card-title.pl-0.py-4(v-bind="attrs" v-on="on") {{ pageTitle }}
        v-card-subtitle.pl-0.pb-2(v-if="pageDescription") {{ pageDescription }} &nbsp;

    span
      span.text-md.font-weight-medium {{ pageTitle }}
      br
      span.font-weight-light {{ pageDescription }}

  v-spacer

  slot(name="left")

  //- Ações não agrupáveis
  action-bar-ex-pin(
    v-for="(action,index) in pins"
    :key="`pin-${index}`"
    :entity="entity"
    :data="data"
    :row="row"
    :action="action"
    @perform="opts => $emit('perform', opts)"
  )
    //- :color="getColor(action)"

  //- Ações agrupáveis
  v-menu(
    v-for="(category, index) in groupedPins"
    :key="`menu-${category}`"
    offset-y
  )
    template(#activator="{ on, attrs }")
      v-btn(
        v-bind="attrs"
        v-on="on"
        text
        rounded
      )
        v-icon mdi-menu-down
        | {{ category }}
    v-list
      action-bar-ex-menu-item(
        v-for="(action,index) in pins.links.filter(x => x.category === category)"
        :key="`menu-${category}-${index}`"
        :entity="entity"
        :data="data"
        :row="row"
        :action="action"
        @perform="opts => $emit('perform', opts)"
      )

  slot(name="right")

  //- BOTÃO FECHAR
  v-tooltip(bottom v-if="showClose")
    template(#activator="{ on, attrs }")
      v-btn(
        icon
        v-bind="attrs"
        v-on="on"
        @click="$close(entity)"
      )
        v-icon mdi-close
    span
      span.text-md.font-weight-medium Fechar
      br
      span.font-weight-light Fecha esta página.
        br
        | Os dados não salvos são perdidos.

</template>

<style>
  .x-btn-navbar {
    border: 1px solid #9995;
  }
</style>

<script>
import ActionBarExPin from '@/components/commons/action-bar-ex/ActionBarExPin'
import ActionBarExMenuItem from '@/components/commons/action-bar-ex/ActionBarExMenuItem'

export default {
  components: {
    ActionBarExPin,
    ActionBarExMenuItem,
  },

  props: {
    /**
     * Instância da entidade atualmente em exbição.
     */
    entity: Object,
    data: Object,
    row: Object,

    /**
     * Ações disponíveis no menu.
     *
     * Esta propriedade recebe um objeto que contém a estrutura de ações organizadas no menu.
     *
     * @type {Object}
     * @property {Array} all - Todas as ações no menu.
     * @property {Array} main - Ações principais no menu.
     * @property {Array} side - Ações secundárias no menu.
     * @property {Array} rest - Outras ações no menu.
     * @property {Array} categories
     *    - Categorias personalizadas no menu, cada uma contendo um nome e um conjunto de ações.
     *
     * @example
     * {
     *   menu: {
     *     all: [...], // Todas as ações da página
     *     main: [...], // Ações principais da página
     *     side: [...], // Ações secundárias da página
     *     rest: [...], // Outras ações da página
     *     categories: [
     *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *       { name: 'Category2', actions: [...] },
     *       // ...
     *     ]
     *   },
     *   pins: {
     *     all: [...], // Todas as ações fixadas da página
     *     main: [...], // Ações principais fixadas da página
     *     side: [...], // Ações secundárias fixadas da página
     *     rest: [...], // Outras ações fixadas da página
     *     categories: [
     *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *       { name: 'Category2', actions: [...] },
     *       // ...
     *     ]
     *   }
     * }
     */
    actions: Object,

    title: String,
    description: String,

    context: Object,

    allowTitle: Boolean,
    allowClose: Boolean,
  },

  computed: {
    // eref: vm => vm.$route.params.eref,
    // site: vm => vm.$route.params.site,

    pageTitle: vm => vm.title || vm.title || vm.entity?.title || vm.entity?.name || vm.entity?.eref,
    pageDescription: vm => vm.description || vm.entity?.description || `Página de ${vm.pageTitle}.`,

    showTitle: vm => vm.allowTitle,
    showClose: vm => vm.allowClose && vm.site !== 'Home' && vm.eref !== 'Index.Workspace',

    pins() {
      const category = this.actions.pins.categories.find(category => !category.name)
      return category?.actions || []
    },

    groupedPins() {
      return this.actions.menu.categories.filter(category => category.name)
    },

    // links () {
    //   const items = this.entity?.links || []
    //   computeAll(items, this.context)
    //   return items.filter(item => !item.hidden)
    // },

    // actions: vm => findRels(vm.links, 'Action'),
    // acts () {
    //   const links = [
    //     ...findRels(this.actions, 'Primary'),
    //     ...findRels(this.actions, 'Secondary'),
    //     ...findRels(this.actions, { excludes: [ 'Primary', 'Secondary' ] }),
    //   ]
    //   const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
    //   return { categories, links }
    // },
    // pins () {
    //   const links = [
    //     ...findRels(this.actions, { includes: [ 'Pinned', 'Primary']}),
    //     ...findRels(this.actions, { includes: [ 'Pinned', 'Secondary' ]}),
    //     ...findRels(this.actions, { includes: [ 'Pinned' ], excludes: [ 'Primary', 'Secondary' ] }),
    //   ]
    //   const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
    //   return { categories, links }
    // },
  },
}
</script>